import React from "react";
import styled from "styled-components";

const ButtonForm = styled.button`
  width: ${(props) => props.widthSize || "100%"};
  height: 30px;
  border-radius: 8px;
  padding: 4px;
  color: white;
  font-size: 12px;
  font-weight: 700;
  background-color: #178af4;
  border: 1px solid #e2e0e0;
  margin-top: ${(props) => props.marginTop || "0"};
`;

const Button = ({ children, onClick, widthSize, marginTop }) => {
  return (
    <ButtonForm onClick={onClick} widthSize={widthSize} marginTop={marginTop}>
      {children}{" "}
    </ButtonForm>
  );
};

export default Button;
